import React from "react";
import axios from "axios";
import { connect } from "react-redux";

import { Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { Block, FreeBreakfast, GetApp } from "@mui/icons-material";

import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import CardHeader from "../../../components/Card/CardHeader";
import CardIcon from "../../../components/Card/CardIcon";
import GridContainer from "../../../components/Grid/GridContainer";
import GridItem from "../../../components/Grid/GridItem";
import Button from "../../../components/CustomButtons/Button";
//import CustomSwitch from "../../../components/CustomInput/CustomSwitch";
import SaveButton from "../../../components/CustomInput/SaveButton";

import Filters from "../Components/Filters";

import * as actions from "../../../store/actions";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper.tsx";

import { withStyles } from "tss-react/mui";
import rapportenStyle from "../../../assets/jss/material-dashboard-pro-react/views/rapportenStyle";
import { toast } from "react-toastify";
import { format } from "date-fns";

class Export extends React.Component {
  state = {
    salesTimeSlotsOverPeriode: {
      items: {},
      totalen: {
        waarde: 0,
        aantal: 0,
      },
    },
    salesExportInitData: {
      vestiging_id: null,
      dateFrom: null,
      dateUntil: null,
    },
    excellRap_001: {
      buttonInitialized: null,
      downloadAvailable: null,
      loading: false,
      downloadLink: null,
      count: null,
      saving: false,
    },
    excellRap_002: {
      buttonInitialized: null,
      downloadAvailable: null,
      loading: false,
      downloadLink: null,
      count: null,
      saving: false,
    },
    excellRap_003: {
      buttonInitialized: null,
      downloadAvailable: null,
      loading: false,
      downloadLink: null,
      count: null,
      saving: false,
    },
    excellRap_004: {
      buttonInitialized: null,
      downloadAvailable: null,
      loading: false,
      downloadLink: null,
      count: null,
      saving: false,
    },
    excellRap_005: {
      buttonInitialized: null,
      downloadAvailable: null,
      loading: false,
      downloadLink: null,
      count: null,
      saving: false,
    },
    excellRap_006: {
      buttonInitialized: null,
      downloadAvailable: null,
      loading: false,
      downloadLink: null,
      count: null,
      saving: false,
    },
  };

  currentReqeust;

  /* function */
  getData = (filterData) => {
    toast.info(<TranslationWrapper tDefault={"laden"} tKey={"global.laden"} />);

    let data = {
      vestiging_ids: filterData.vestiging_ids,
      start_datum: format(new Date(filterData.start_datum), "yyyy-M-d HH:mm:ss"),
      eind_datum: format(new Date(filterData.eind_datum), "yyyy-M-d HH:mm:ss"),
    };

    if (this.currentReqeust !== undefined) {
      this.currentReqeust.cancel();
    }

    const CancelToken = axios.CancelToken;
    this.currentReqeust = CancelToken.source();
    let cancelToken = this.currentReqeust.token;

    axios
      .post("core/rapporten/sales_export_init", data, {
        cancelToken: cancelToken,
      })
      .then((response) => {
        let newState = {
          ...this.state,
          ...response.data.data,
          excellRap_001: {
            buttonInitialized: true,
            downloadAvailable: null,
            downloadLink: null,
            count: null,
            saving: false,
          },
          excellRap_002: {
            buttonInitialized: true,
            downloadAvailable: null,
            downloadLink: null,
            count: null,
            saving: false,
          },
          excellRap_003: {
            buttonInitialized: true,
            downloadAvailable: null,
            downloadLink: null,
            count: null,
            saving: false,
          },
          excellRap_004: {
            buttonInitialized: true,
            downloadAvailable: null,
            downloadLink: null,
            count: null,
            saving: false,
          },
          excellRap_005: {
            buttonInitialized: true,
            downloadAvailable: null,
            downloadLink: null,
            count: null,
            saving: false,
          },
          excellRap_006: {
            buttonInitialized: true,
            downloadAvailable: null,
            downloadLink: null,
            count: null,
            saving: false,
          },
        };
        this.setState(newState);
      })
      .catch((error) => {
        /**
         * Alleen niet CANCEL errors afvangen
         */
        if (!error.__CANCEL__) {
          toast.error(
            <TranslationWrapper tDefault={"Oeps er is iets misgegaan!"} tKey={"global.rapporten.errormessage"} />
          );
        }
      });
  };

  /* Rapportagefunction 001*/
  excellRap_001_handlePrepareDownload = (filterData) => {
    // handle prepare download
    toast.info(<TranslationWrapper tDefault={"laden"} tKey={"global.laden"} />);

    let newExcellRap_001 = this.state.excellRap_001;
    newExcellRap_001["loading"] = true;
    this.setState({ newExcellRap_001 });

    let data = {
      vestiging_ids: this.state.salesExportInitData.vestiging_id,
      start_datum: this.state.salesExportInitData.dateFrom,
      eind_datum: this.state.salesExportInitData.dateUntil,
    };

    if (this.currentReqeust !== undefined) {
      this.currentReqeust.cancel();
    }

    const CancelToken = axios.CancelToken;
    this.currentReqeust = CancelToken.source();
    let cancelToken = this.currentReqeust.token;

    axios
      .post("core/rapporten/sales_export_buildExcelDataFile_orderReport", data, {
        cancelToken: cancelToken,
      })
      .then((response) => {
        let linkDataFile = response.data.data.filename;

        //update state
        let newExcellRap_001 = this.state.excellRap_001;
        newExcellRap_001["downloadAvailable"] = true;
        newExcellRap_001["loading"] = false;
        newExcellRap_001["downloadLink"] = linkDataFile;
        newExcellRap_001["count"] = response.data.data.count;
        this.setState({ excellRap_001: newExcellRap_001 });
      })
      .catch((error) => {
        //Error message to user if it wasn't a user abort
        if (!error.__CANCEL__) {
          toast.error(
            <TranslationWrapper tDefault={"Oeps er is iets misgegaan!"} tKey={"global.rapporten.errormessage"} />
          );
        }
      });
  };

  excellRap_004_handlePrepareDownload = (filterData) => {
    // handle prepare download
    toast.info(<TranslationWrapper tDefault={"laden"} tKey={"global.laden"} />);

    let newExcellRap_004 = this.state.excellRap_004;
    newExcellRap_004["loading"] = true;
    this.setState({ newExcellRap_004 });

    let data = {
      vestiging_ids: this.state.salesExportInitData.vestiging_id,
      start_datum: this.state.salesExportInitData.dateFrom,
      eind_datum: this.state.salesExportInitData.dateUntil,
    };

    if (this.currentReqeust !== undefined) {
      this.currentReqeust.cancel();
    }

    const CancelToken = axios.CancelToken;
    this.currentReqeust = CancelToken.source();
    let cancelToken = this.currentReqeust.token;

    axios
      .post("core/rapporten/sales_export_buildExcelDataFile_orderReport_paid", data, {
        cancelToken: cancelToken,
      })
      .then((response) => {
        let linkDataFile = response.data.data.filename;

        //update state
        let newExcellRap_004 = this.state.excellRap_004;
        newExcellRap_004["downloadAvailable"] = true;
        newExcellRap_004["loading"] = false;
        newExcellRap_004["downloadLink"] = linkDataFile;
        newExcellRap_004["count"] = response.data.data.count;
        this.setState({ excellRap_004: newExcellRap_004 });
      })
      .catch((error) => {
        //Error message to user if it wasn't a user abort
        if (!error.__CANCEL__) {
          toast.error(
            <TranslationWrapper tDefault={"Oeps er is iets misgegaan!"} tKey={"global.rapporten.errormessage"} />
          );
        }
      });
  };

  excellRap_005_handlePrepareDownload = (filterData) => {
    // handle prepare download
    toast.info(<TranslationWrapper tDefault={"laden"} tKey={"global.laden"} />);
    let newExcellRap_005 = this.state.excellRap_005;
    newExcellRap_005["loading"] = true;
    this.setState({ newExcellRap_005 });
    let data = {
      vestiging_ids: this.state.salesExportInitData.vestiging_id,
      start_datum: this.state.salesExportInitData.dateFrom,
      eind_datum: this.state.salesExportInitData.dateUntil,
    };

    if (this.currentReqeust !== undefined) {
      this.currentReqeust.cancel();
    }

    const CancelToken = axios.CancelToken;
    this.currentReqeust = CancelToken.source();
    let cancelToken = this.currentReqeust.token;

    axios
      .post("core/rapporten/order_export_external_orderid", data, {
        cancelToken: cancelToken,
      })
      .then((response) => {
        let linkDataFile = response.data.data.filename;

        //update state
        let newExcellRap_005 = this.state.excellRap_005;
        newExcellRap_005["downloadAvailable"] = true;
        newExcellRap_005["loading"] = false;
        newExcellRap_005["downloadLink"] = linkDataFile;
        newExcellRap_005["count"] = response.data.data.count;
        this.setState({ excellRap_005: newExcellRap_005 });
      })
      .catch((error) => {
        //Error message to user if it wasn't a user abort
        if (!error.__CANCEL__) {
          toast.error(
            <TranslationWrapper tDefault={"Oeps er is iets misgegaan!"} tKey={"global.rapporten.errormessage"} />
          );
        }
      });
  };

  /* Rapportagefunction 002*/
  excellRap_002_handlePrepareDownload = (filterData) => {
    // handle prepare download
    toast.info(<TranslationWrapper tDefault={"laden"} tKey={"global.laden"} />);
    let newExcellRap_002 = this.state.excellRap_002;
    newExcellRap_002["loading"] = true;
    this.setState({ newExcellRap_002 });
    let data = {
      vestiging_ids: this.state.salesExportInitData.vestiging_id,
      start_datum: this.state.salesExportInitData.dateFrom,
      eind_datum: this.state.salesExportInitData.dateUntil,
    };

    if (this.currentReqeust !== undefined) {
      this.currentReqeust.cancel();
    }

    const CancelToken = axios.CancelToken;
    this.currentReqeust = CancelToken.source();
    let cancelToken = this.currentReqeust.token;

    axios
      .post("core/rapporten/sales_export_buildExcelDataFile_orderReport_extended", data, {
        cancelToken: cancelToken,
      })
      .then((response) => {
        let linkDataFile = response.data.data.filename;

        //update state
        let newExcellRap_002 = this.state.excellRap_002;
        newExcellRap_002["downloadAvailable"] = true;
        newExcellRap_002["loading"] = false;
        newExcellRap_002["downloadLink"] = linkDataFile;
        newExcellRap_002["count"] = response.data.data.count;
        this.setState({ excellRap_002: newExcellRap_002 });
      })
      .catch((error) => {
        //Error message to user if it wasn't a user abort
        if (!error.__CANCEL__) {
          toast.error(
            <TranslationWrapper tDefault={"Oeps er is iets misgegaan!"} tKey={"global.rapporten.errormessage"} />
          );
        }
      });
  };

  /* Rapportagefunction 006*/
  excellRap_006_handlePrepareDownload = (filterData) => {
    // handle prepare download
    toast.info(<TranslationWrapper tDefault={"laden"} tKey={"global.laden"} />);
    let newExcellRap_006 = this.state.excellRap_006;
    newExcellRap_006["loading"] = true;
    this.setState({ newExcellRap_006 });
    let data = {
      vestiging_ids: this.state.salesExportInitData.vestiging_id,
      start_datum: this.state.salesExportInitData.dateFrom,
      eind_datum: this.state.salesExportInitData.dateUntil,
    };

    if (this.currentReqeust !== undefined) {
      this.currentReqeust.cancel();
    }

    const CancelToken = axios.CancelToken;
    this.currentReqeust = CancelToken.source();
    let cancelToken = this.currentReqeust.token;

    axios
      .post("core/rapporten/sales_export_buildExcelDataFile_orderReport_extended_failed", data, {
        cancelToken: cancelToken,
      })
      .then((response) => {
        let linkDataFile = response.data.data.filename;

        //update state
        let newExcellRap_006 = this.state.excellRap_006;
        newExcellRap_006["downloadAvailable"] = true;
        newExcellRap_006["loading"] = false;
        newExcellRap_006["downloadLink"] = linkDataFile;
        newExcellRap_006["count"] = response.data.data.count;
        this.setState({ excellRap_006: newExcellRap_006 });
      })
      .catch((error) => {
        //Error message to user if it wasn't a user abort
        if (!error.__CANCEL__) {
          toast.error(
            <TranslationWrapper tDefault={"Oeps er is iets misgegaan!"} tKey={"global.rapporten.errormessage"} />
          );
        }
      });
  };

  /* Rapportagefunction 003*/
  excellRap_003_handlePrepareDownload = (filterData) => {
    // handle prepare download
    toast.info(<TranslationWrapper tDefault={"laden"} tKey={"global.laden"} />);
    let newExcellRap_003 = this.state.excellRap_003;
    newExcellRap_003["loading"] = true;
    this.setState({ newExcellRap_003 });
    let data = {
      vestiging_ids: this.state.salesExportInitData.vestiging_id,
      start_datum: this.state.salesExportInitData.dateFrom,
      eind_datum: this.state.salesExportInitData.dateUntil,
    };

    if (this.currentReqeust !== undefined) {
      this.currentReqeust.cancel();
    }

    const CancelToken = axios.CancelToken;
    this.currentReqeust = CancelToken.source();
    let cancelToken = this.currentReqeust.token;

    axios
      .post("core/rapporten/sales_export_buildExcelDataFile_preOrderReport", data, {
        cancelToken: cancelToken,
      })
      .then((response) => {
        let linkDataFile = response.data.data.filename;

        //update state
        let newExcellRap_003 = this.state.excellRap_003;
        newExcellRap_003["loading"] = false;
        newExcellRap_003["downloadAvailable"] = true;
        newExcellRap_003["downloadLink"] = linkDataFile;
        newExcellRap_003["count"] = response.data.data.count;
        this.setState({ excellRap_003: newExcellRap_003 });
      })
      .catch((error) => {
        //Error message to user if it wasn't a user abort
        if (!error.__CANCEL__) {
          toast.error(
            <TranslationWrapper tDefault={"Oeps er is iets misgegaan!"} tKey={"global.rapporten.errormessage"} />
          );
        }
      });
  };

  /* render */
  render() {
    const { classes } = this.props;

    //salesAreas
    let selectedSalesareasText = "--";
    let selected = this.state.salesExportInitData.vestiging_id;
    if (selected) {
      if (selected == "all" || selected.length == 0) {
        selectedSalesareasText = <TranslationWrapper tDefault={"All"} tKey={"rapportages.filters.alleVestigingen"} />;
      } else {
        let selected2 = selected.length;
        selectedSalesareasText = selected2.toString() + " selected. " + JSON.stringify(selected);
      }
    }

    // button_excellRap_001
    let button_excellRap_001 = "";
    if (this.state.excellRap_001.buttonInitialized === null) {
      button_excellRap_001 = <span>..initializing..</span>;
    } else {
      if (this.state.excellRap_001.downloadAvailable === null && !this.state.excellRap_001.loading) {
        button_excellRap_001 = (
          <SaveButton
            buttonText={
              <TranslationWrapper
                tDefault={"Genereer download file"}
                tKey={"tafels.modal.downloadQrCode.form.button.genDownload"}
              />
            }
            onClick={this.excellRap_001_handlePrepareDownload}
            saving={this.state.excellRap_001.saving}
          />
        );
      } else if (this.state.excellRap_001.loading) {
        button_excellRap_001 = (
          <Button>
            <Block /> LOADING ...
          </Button>
        );
      } else {
        if (this.state.excellRap_001.count == 0) {
          button_excellRap_001 = (
            <Button>
              <Block /> NO ORDERS FOUND ({this.state.excellRap_001.count})
            </Button>
          );
        } else {
          button_excellRap_001 = (
            <Button download={this.state.excellRap_001.downloadLink} href={this.state.excellRap_001.downloadLink}>
              <GetApp />{" "}
              {
                <TranslationWrapper
                  tDefault={"Bestand downloaden"}
                  tKey={"tafels.modal.downloadQrCode.form.button.downloadFile"}
                />
              }{" "}
              ({this.state.excellRap_001.count} orders)
            </Button>
          );
        }
      }
    }

    // button_excellRap_001
    let button_excellRap_004 = "";
    if (this.state.excellRap_004.buttonInitialized === null) {
      button_excellRap_004 = <span>..initializing..</span>;
    } else {
      if (this.state.excellRap_004.downloadAvailable === null && !this.state.excellRap_004.loading) {
        button_excellRap_004 = (
          <SaveButton
            buttonText={
              <TranslationWrapper
                tDefault={"Genereer download file"}
                tKey={"tafels.modal.downloadQrCode.form.button.genDownload"}
              />
            }
            onClick={this.excellRap_004_handlePrepareDownload}
            saving={this.state.excellRap_004.saving}
          />
        );
      } else if (this.state.excellRap_004.loading) {
        button_excellRap_004 = (
          <Button>
            <Block /> LOADING ...
          </Button>
        );
      } else {
        if (this.state.excellRap_004.count == 0) {
          button_excellRap_004 = (
            <Button>
              <Block /> NO ORDERS FOUND ({this.state.excellRap_004.count})
            </Button>
          );
        } else {
          button_excellRap_004 = (
            <Button download={this.state.excellRap_004.downloadLink} href={this.state.excellRap_004.downloadLink}>
              <GetApp />{" "}
              {
                <TranslationWrapper
                  tDefault={"Bestand downloaden"}
                  tKey={"tafels.modal.downloadQrCode.form.button.downloadFile"}
                />
              }{" "}
              ({this.state.excellRap_004.count} orders)
            </Button>
          );
        }
      }
    }

    // button_excellRap_002
    let button_excellRap_002 = "";
    if (this.state.excellRap_002.buttonInitialized === null) {
      button_excellRap_002 = <span>..initializing..</span>;
    } else {
      if (this.state.excellRap_002.downloadAvailable === null && !this.state.excellRap_002.loading) {
        button_excellRap_002 = (
          <SaveButton
            buttonText={
              <TranslationWrapper
                tDefault={"Genereer download file"}
                tKey={"tafels.modal.downloadQrCode.form.button.genDownload"}
              />
            }
            onClick={this.excellRap_002_handlePrepareDownload}
            saving={this.state.excellRap_002.saving}
          />
        );
      } else if (this.state.excellRap_002.loading) {
        button_excellRap_002 = (
          <Button>
            <Block /> LOADING ...
          </Button>
        );
      } else {
        if (this.state.excellRap_002.count == 0) {
          button_excellRap_002 = (
            <Button>
              <Block /> NO ORDERS FOUND ({this.state.excellRap_002.count})
            </Button>
          );
        } else {
          button_excellRap_002 = (
            <Button download={this.state.excellRap_002.downloadLink} href={this.state.excellRap_002.downloadLink}>
              <GetApp />{" "}
              {
                <TranslationWrapper
                  tDefault={"Bestand downloaden"}
                  tKey={"tafels.modal.downloadQrCode.form.button.downloadFile"}
                />
              }{" "}
              ({this.state.excellRap_002.count} orders)
            </Button>
          );
        }
      }
    }

    // button_excellRap_006
    let button_excellRap_006 = "";
    if (this.state.excellRap_006.buttonInitialized === null) {
      button_excellRap_006 = <span>..initializing..</span>;
    } else {
      if (this.state.excellRap_006.downloadAvailable === null && !this.state.excellRap_006.loading) {
        button_excellRap_006 = (
          <SaveButton
            buttonText={
              <TranslationWrapper
                tDefault={"Genereer download file"}
                tKey={"tafels.modal.downloadQrCode.form.button.genDownload"}
              />
            }
            onClick={this.excellRap_006_handlePrepareDownload}
            saving={this.state.excellRap_006.saving}
          />
        );
      } else if (this.state.excellRap_006.loading) {
        button_excellRap_006 = (
          <Button>
            <Block /> LOADING ...
          </Button>
        );
      } else {
        if (this.state.excellRap_006.count == 0) {
          button_excellRap_006 = (
            <Button>
              <Block /> NO ORDERS FOUND ({this.state.excellRap_006.count})
            </Button>
          );
        } else {
          button_excellRap_006 = (
            <Button download={this.state.excellRap_006.downloadLink} href={this.state.excellRap_006.downloadLink}>
              <GetApp />{" "}
              {
                <TranslationWrapper
                  tDefault={"Bestand downloaden"}
                  tKey={"tafels.modal.downloadQrCode.form.button.downloadFile"}
                />
              }{" "}
              ({this.state.excellRap_006.count} orders)
            </Button>
          );
        }
      }
    }

    // button_excellRap_003
    let button_excellRap_003 = "";
    if (this.state.excellRap_003.buttonInitialized === null) {
      button_excellRap_003 = <span>..initializing..</span>;
    } else {
      if (this.state.excellRap_003.downloadAvailable === null && !this.state.excellRap_003.loading) {
        button_excellRap_003 = (
          <SaveButton
            buttonText={
              <TranslationWrapper
                tDefault={"Genereer download file"}
                tKey={"tafels.modal.downloadQrCode.form.button.genDownload"}
              />
            }
            onClick={this.excellRap_003_handlePrepareDownload}
            saving={this.state.excellRap_003.saving}
          />
        );
      } else if (this.state.excellRap_003.loading) {
        button_excellRap_003 = (
          <Button>
            <Block /> LOADING ...
          </Button>
        );
      } else {
        if (this.state.excellRap_003.count == 0) {
          button_excellRap_003 = (
            <Button>
              <Block /> NO ORDERS FOUND ({this.state.excellRap_003.count})
            </Button>
          );
        } else {
          button_excellRap_003 = (
            <Button download={this.state.excellRap_003.downloadLink} href={this.state.excellRap_003.downloadLink}>
              <GetApp />{" "}
              {
                <TranslationWrapper
                  tDefault={"Bestand downloaden"}
                  tKey={"tafels.modal.downloadQrCode.form.button.downloadFile"}
                />
              }{" "}
              ({this.state.excellRap_003.count} orders)
            </Button>
          );
        }
      }
    }

    let button_excellRap_005 = "";
    if (this.state.excellRap_005.buttonInitialized === null) {
      button_excellRap_005 = <span>..initializing..</span>;
    } else {
      if (this.state.excellRap_005.downloadAvailable === null) {
        button_excellRap_005 = (
          <SaveButton
            buttonText={
              <TranslationWrapper
                tDefault={"Genereer download file"}
                tKey={"tafels.modal.downloadQrCode.form.button.genDownload"}
              />
            }
            onClick={this.excellRap_005_handlePrepareDownload}
            saving={this.state.excellRap_005.saving}
          />
        );
      } else {
        if (this.state.excellRap_005.count == 0 && !this.state.excellRap_005.loading) {
          button_excellRap_005 = (
            <Button>
              <Block /> NO ORDERS FOUND ({this.state.excellRap_005.count})
            </Button>
          );
        } else if (this.state.excellRap_005.loading) {
          button_excellRap_005 = (
            <Button>
              <Block /> LOADING ...
            </Button>
          );
        } else {
          button_excellRap_005 = (
            <Button download={this.state.excellRap_005.downloadLink} href={this.state.excellRap_005.downloadLink}>
              <GetApp />{" "}
              {
                <TranslationWrapper
                  tDefault={"Bestand downloaden"}
                  tKey={"tafels.modal.downloadQrCode.form.button.downloadFile"}
                />
              }{" "}
              ({this.state.excellRap_005.count} orders)
            </Button>
          );
        }
      }
    }

    // //  //zzdev - not yet available
    //  let button_excellRap_003 =
    //      <span>Not Yet Available<br></br>(coming soon)</span>
    //  ;

    return (
      <div>
        <Filters onFilterChange={this.getData} showEndDate showStartDate showVestigingen />
        <GridContainer>
          <GridItem lg={12} md={12} sm={12} xs={12}>
            <Card>
              <CardHeader color={"primary"} icon>
                <CardIcon color={"primary"}>
                  <FreeBreakfast />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>
                  <TranslationWrapper
                    tDefault={"Download Excel reportage"}
                    tKey={"rapportages.rapporten.export.downloadExcelRapportage"}
                  />
                </h4>
              </CardHeader>

              <CardBody>
                <Card>
                  <CardBody>
                    <h5>
                      <TranslationWrapper
                        tDefault={"Selection data"}
                        tKey={"rapportages.rapporten.export.selectionData"}
                      />
                    </h5>
                    <GridContainer>
                      <GridItem sm={2} xs={12}>
                        <TranslationWrapper tDefault={"Van"} tKey={"global.van"} />
                      </GridItem>
                      <GridItem sm={10} xs={12}>
                        {this.state.salesExportInitData.dateFrom}
                      </GridItem>
                    </GridContainer>
                    <GridContainer>
                      <GridItem sm={2} xs={12}>
                        <TranslationWrapper tDefault={"Tot"} tKey={"global.tot"} />
                      </GridItem>
                      <GridItem sm={10} xs={12}>
                        {this.state.salesExportInitData.dateUntil}
                      </GridItem>
                    </GridContainer>
                    <GridContainer>
                      <GridItem sm={2} xs={12}>
                        <TranslationWrapper tDefault={"Vestiging"} tKey={"global.Vestiging"} />
                      </GridItem>
                      <GridItem sm={10} xs={12}>
                        {selectedSalesareasText}
                      </GridItem>
                    </GridContainer>
                  </CardBody>
                </Card>

                {/* Overview */}
                <div className={classes.tableResponsive}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>
                          <TranslationWrapper tDefault={"Export"} tKey={"rapportages.rapporten.export.table.export"} />
                        </TableCell>
                        <TableCell>
                          <TranslationWrapper
                            tDefault={"Description"}
                            tKey={"rapportages.rapporten.export.table.description"}
                          />
                        </TableCell>
                        <TableCell>
                          <TranslationWrapper
                            tDefault={"Download"}
                            tKey={"rapportages.rapporten.export.table.download"}
                          />
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {/* excellRap_004 */}
                      <TableRow>
                        <TableCell>
                          <b>
                            <TranslationWrapper
                              tDefault={"Order Report paid orders"}
                              tKey={"rapportages.rapporten.export.table.orderReportPaid"}
                            />
                          </b>
                        </TableCell>
                        <TableCell>
                          <TranslationWrapper
                            tDefault={
                              "Export naar excel formaat: Genereert een rapportage over de ingegeven periode (3 sheets.) van betaalde bestellingen"
                            }
                            tKey={"rapportages" + "." + "rapporten.export.table.orderReport.descrHeader"}
                          />
                          <br />
                          <TranslationWrapper
                            tDefault={
                              "- Sheet 1 (Orders): De eerste sheet bevat een overzicht van alle bestellingen zonder product-details."
                            }
                            tKey={"rapportages" + "." + "rapporten.export.table.orderReport.descrSheet1"}
                          />
                          <br />
                          <TranslationWrapper
                            tDefault={
                              "- Sheet 2 (Details): De tweede sheet bevat een overzicht van alle bestellingen inclusief product-details"
                            }
                            tKey={"rapportages" + "." + "rapporten.export.table.orderReport.descrSheet2"}
                          />
                          <br />
                          <TranslationWrapper
                            tDefault={
                              "- Sheet 3 (Sommatie): De derde sheet bevat een totaaltelling over de gekozen periode"
                            }
                            tKey={"rapportages" + "." + "rapporten.export.table.orderReport.descrSheet3"}
                          />
                        </TableCell>
                        <TableCell>{button_excellRap_004}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <b>
                            <TranslationWrapper
                              tDefault={"Order Report"}
                              tKey={"rapportages.rapporten.export.table.orderReport"}
                            />
                          </b>
                        </TableCell>
                        <TableCell>
                          <TranslationWrapper
                            tDefault={
                              "Export naar excel formaat: Genereert een rapportage over de ingegeven periode (3 sheets.)"
                            }
                            tKey={"rapportages" + "." + "rapporten.export.table.orderReport.descrHeader"}
                          />
                          <br />
                          <TranslationWrapper
                            tDefault={
                              "- Sheet 1 (Orders): De eerste sheet bevat een overzicht van alle bestellingen zonder product-details."
                            }
                            tKey={"rapportages" + "." + "rapporten.export.table.orderReport.descrSheet1"}
                          />
                          <br />
                          <TranslationWrapper
                            tDefault={
                              "- Sheet 2 (Details): De tweede sheet bevat een overzicht van alle bestellingen inclusief product-details"
                            }
                            tKey={"rapportages" + "." + "rapporten.export.table.orderReport.descrSheet2"}
                          />
                          <br />
                          <TranslationWrapper
                            tDefault={
                              "- Sheet 3 (Sommatie): De derde sheet bevat een totaaltelling over de gekozen periode"
                            }
                            tKey={"rapportages" + "." + "rapporten.export.table.orderReport.descrSheet3"}
                          />
                        </TableCell>
                        <TableCell>{button_excellRap_001}</TableCell>
                      </TableRow>

                      {/* excellRap_002 */}
                      <TableRow>
                        <TableCell>
                          <b>
                            <TranslationWrapper
                              tDefault={"Detailed order report"}
                              tKey={"rapportages.rapporten.export.table.detailedOrderReport"}
                            />
                          </b>
                        </TableCell>
                        <TableCell>
                          <TranslationWrapper
                            tDefault={
                              "Uitgebreide variant van bestellingen overzicht. Extra informatie op orders- en details-sheets."
                            }
                            tKey={"rapportages.rapporten.export.table.detailedOrderReport.descrHeader"}
                          />
                          <br />
                          <TranslationWrapper
                            tDefault={
                              "- Sheet 1 (Orders): De eerste sheet bevat een overzicht van alle bestellingen zonder product-details."
                            }
                            tKey={"rapportages" + "." + "rapporten.export.table.detailedOrderReport.descrSheet1"}
                          />
                          <br />
                          <TranslationWrapper
                            tDefault={
                              "- Sheet 2 (Details): De tweede sheet bevat een overzicht van alle bestellingen inclusief product-details"
                            }
                            tKey={"rapportages" + "." + "rapporten.export.table.detailedOrderReport.descrSheet2"}
                          />
                          <br />
                          <TranslationWrapper
                            tDefault={
                              "- Sheet 3(Sommatie): De derde sheet bevat een totaaltelling over de gekozen periode"
                            }
                            tKey={"rapportages" + "." + "rapporten.export.table.detailedOrderReport.descrSheet3"}
                          />
                        </TableCell>
                        <TableCell>{button_excellRap_002}</TableCell>
                      </TableRow>

                      {/* excellRap_006 */}
                      <TableRow>
                        <TableCell>
                          <b>
                            <TranslationWrapper
                              tDefault={"Detailed order report PAID failed orders"}
                              tKey={"rapportages.rapporten.export.table.detailedOrderReportFailed"}
                            />
                          </b>
                        </TableCell>
                        <TableCell>
                          <TranslationWrapper
                            tDefault={
                              "Uitgebreide variant van bestellingen overzicht. Extra informatie op orders- en details-sheets."
                            }
                            tKey={"rapportages.rapporten.export.table.detailedOrderReportFailed.descrHeader"}
                          />
                          <br />
                          <TranslationWrapper
                            tDefault={
                              "- Sheet 1 (Orders): De eerste sheet bevat een overzicht van alle bestellingen zonder product-details."
                            }
                            tKey={"rapportages" + "." + "rapporten.export.table.detailedOrderReportFailed.descrSheet1"}
                          />
                          <br />
                          <TranslationWrapper
                            tDefault={
                              "- Sheet 2 (Details): De tweede sheet bevat een overzicht van alle bestellingen inclusief product-details"
                            }
                            tKey={"rapportages" + "." + "rapporten.export.table.detailedOrderReportFailed.descrSheet2"}
                          />
                          <br />
                          <TranslationWrapper
                            tDefault={
                              "- Sheet 3(Sommatie): De derde sheet bevat een totaaltelling over de gekozen periode"
                            }
                            tKey={"rapportages" + "." + "rapporten.export.table.detailedOrderReportFailed.descrSheet3"}
                          />
                        </TableCell>
                        <TableCell>{button_excellRap_006}</TableCell>
                      </TableRow>

                      {/* excellRap_003 */}
                      <TableRow>
                        <TableCell>
                          <b>
                            <TranslationWrapper
                              tDefault={"Pre-order report"}
                              tKey={"rapportages.rapporten.export.table.preOrderReport"}
                            />
                          </b>
                        </TableCell>
                        <TableCell>
                          <TranslationWrapper
                            tDefault={"Overzicht van alle pre-orders in opgegeven periode."}
                            tKey={"rapportages.rapporten.export.table.preOrderReport.descrHeader"}
                          />
                          <br />
                          <TranslationWrapper
                            tDefault={
                              "- Sheet 2 (Kitchen-View) bevat een productoverzicht per bestelling inclusief eventuele persoons en adresgegevens."
                            }
                            tKey={"rapportages" + "." + "rapporten.export.table.preOrderReport.descrSheet2"}
                          />
                          <br />
                          <TranslationWrapper
                            tDefault={
                              "- Sheet 3 (Product-Count) bevat een totaal-telling van elk te leveren product over de opgegegeven periode."
                            }
                            tKey={"rapportages" + "." + "rapporten.export.table.preOrderReport.descrSheet3"}
                          />
                          <br />
                          <TranslationWrapper
                            tDefault={
                              "- Sheet 4 (Full Details) bevat een uitgebreid detail-overzicht van alle preorders over de opgegegven periode."
                            }
                            tKey={"rapportages" + "." + "rapporten.export.table.preOrderReport.descrSheet4"}
                          />
                          <br />
                          <TranslationWrapper
                            tDefault={
                              "- Sheet 5 (Event-view) bevat een speciaal overzicht voor gebruik bij evenementen."
                            }
                            tKey={"rapportages" + "." + "rapporten.export.table.preOrderReport.descrSheet5"}
                          />
                        </TableCell>
                        <TableCell>{button_excellRap_003}</TableCell>
                      </TableRow>

                      {/* excellRap_005 */}
                      <TableRow>
                        <TableCell>
                          <b>
                            <TranslationWrapper
                              tDefault={"Payment ID to external order id"}
                              tKey={"rapportages.externalOrderId"}
                            />
                          </b>
                        </TableCell>
                        <TableCell>
                          <TranslationWrapper
                            tDefault={
                              "Exports a mapping excel file to reconcile data in for example Microsoft Dynamics."
                            }
                            tKey={"rapportages.descrHeaderExternalOrderID"}
                          />
                        </TableCell>
                        <TableCell>{button_excellRap_005}</TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </div>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    showMessage: (message) => dispatch({ type: actions.SHOW_MESSAGE, message: message }),
    closeMessage: () => dispatch({ type: actions.CLOSE_MESSAGE }),
  };
};

export default connect(null, mapDispatchToProps)(withStyles(Export, rapportenStyle));
